import { useTranslation } from 'react-i18next';
import {
  TestimonialsContent,
  TestimonialsDescription,
  TestimonialsLogo,
  TestimonialsLogoContent,
  TestimonialsSection,
  TestimonialsTitle,
  TestimonialsWrapper,
} from './Testimonials.styled';
import logo from '../../../static/trusted_logos/migrapreneur-logo-copy.png';

const Testimonials = () => {
  const { t } = useTranslation();
  return (
    <TestimonialsSection id="testimonials">
      <TestimonialsWrapper>
        <TestimonialsContent>
          <TestimonialsTitle>{t('testimonials_title')}</TestimonialsTitle>
          <TestimonialsLogoContent>
          {/* <-- This needs to be a block of testimonials */}
            <TestimonialsLogo src={logo} alt="testimonial-logo" />
            <TestimonialsDescription>
             <strong>{t('testimonials_author_01')}</strong>
             <br></br>
              <small>{t('testimonials_org_01')}</small>
              <br></br>
              <br></br>
             <i>{t('testimonials_desc_01')}</i>
          {/* This needs to be a block of testimonials --> */}
            </TestimonialsDescription>
          </TestimonialsLogoContent>
        </TestimonialsContent>
      </TestimonialsWrapper>
    </TestimonialsSection>
  );
};

export default Testimonials;
